// Se usa fetch y no axios para que la consulta no pase por los interceptores
// de main.js, que son justamente los que la disparan cuando algo falla.
const ESPERA_MAXIMA_MS = 5000;

export const saludService = {
    backendDisponible,
};

// Se resuelve con true si el backend responde a /salud/ con 2xx dentro del
// plazo; con false ante cualquier otra cosa. Nunca se rechaza.
function backendDisponible() {
    const controlador = new AbortController();
    const plazo = setTimeout(() => controlador.abort(), ESPERA_MAXIMA_MS);

    return fetch(`${process.env.VUE_APP_API_URL}/salud/`, { signal: controlador.signal, cache: 'no-store' })
        .then(respuesta => respuesta.ok)
        .catch(() => false)
        .finally(() => clearTimeout(plazo));
}
